import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { ICustomer } from "../../utils/types/models";

export default createEntityReducer<ICustomer>(Endpoint.Customers, Endpoint.CustomersList);
